// Import
import { Box, Button, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import MultiSelectCst from "@components/InputCst/MultiSelectCst";
import { useTranslation } from "react-i18next";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import { useFetchDataDetail } from "@hooks/useFetchDetail";
import { useParams } from "react-router-dom";

interface DashboardRolesModalCstInterface {
  title?: string;
  description?: string;
  cancelText?: string;
  submitText?: string;
  data?: any;
  onSubmitAction?: any;
  onCancelAction: () => void;
  selectChoiceError?: boolean;
  service?: string;
  selectLabel?: string;
  dashboarItem?: any;
}

const DashboardRolesModalCst: React.FC<DashboardRolesModalCstInterface> = ({
  title,
  description,
  cancelText,
  submitText,
  data,
  onSubmitAction,
  onCancelAction,
  selectChoiceError,
  service,
  selectLabel,
  dashboarItem,
}) => {
  const theme = useTheme();
  const { id = "1" } = useParams();
  const [value, setValue] = useState([]);
  const [finalValue, setFinalValue] = useState([]);
  const [options, setOptions] = useState([]);
  const { t } = useTranslation(["modal"]);

  const { dataDetail: allRoles } = useFetchDataDetail(
    `${ServicesURL.getRoles}?corporateId=${id}`,
    PagesID["dashboard.corporate-association"],
  );

  useEffect(() => {
    const filteredArray = allRoles.filter((item: any) =>
      value.some(
        (filterItem: any) => filterItem.label === item.customRoleDescription,
      ),
    );

    setFinalValue(filteredArray);
  }, [value]);

  useEffect(() => {
    const formattedResponseList = allRoles.filter((item: any) =>
      dashboarItem.associatedRoles.some(
        (filterItem: any) => filterItem === item.roleKey,
      ),
    );

    const stringResponse = formattedResponseList.map((item: any) => {
      return item.customRoleDescription;
    });

    const optionsCalculated = allRoles.map((role: any) => {
      return {
        value: role.id,
        label: role.customRoleDescription,
      };
    });

    const selected = optionsCalculated.filter((item: any) =>
      stringResponse.some((filterItem: any) => filterItem === item.label),
    );

    setValue(selected);
    setOptions(optionsCalculated);
  }, [allRoles]);

  return (
    <Box
      sx={{
        minHeight: "200px",
        alignItems: "stretch",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2 style={{ margin: "0" }} id="parent-modal-title">
          {title}
        </h2>
        <Button
          onClick={() => onCancelAction()}
          sx={{
            borderRadius: "50%",
            minWidth: "0",
            padding: "0 3px",
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            span: {
              width: "0",
            },
          }}
        >
          <CloseIcon fontSize="large" />
        </Button>
      </Box>
      <p id="parent-modal-description">{description}</p>
      <Box sx={{ mt: 6, maxWidth: "300px" }}>
        <MultiSelectCst
          id={"lo"}
          label={selectLabel ? selectLabel : "Learning Object"}
          options={options}
          // service={service}
          value={value}
          disabled={false}
          onChange={(e: any) => {
            setValue(e);
          }}
          required={true}
        />
      </Box>
      {selectChoiceError && (
        <Typography
          sx={{
            color: theme.palette.error.main,
            mt: 2,
          }}
        >
          {t("select-choice-error")}
        </Typography>
      )}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          columnGap: "20px",
          rowGap: "10px",
          // minHeight: '90px',
          mt: 10,
          alignItems: "end",
        }}
      >
        {cancelText && (
          <Button
            id={"add-button1"}
            variant={"outlined"}
            size={"medium"}
            sx={{
              minWidth: "200px",
            }}
            onClick={() => onCancelAction()}
          >
            {cancelText}
          </Button>
        )}
        {submitText && (
          <Button
            id={"add-button1"}
            variant={"contained"}
            size={"medium"}
            sx={{
              minWidth: "200px",
            }}
            onClick={() => {
              onSubmitAction(finalValue, allRoles);
            }}
          >
            {submitText}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default DashboardRolesModalCst;
